import type { LocalizedContent, WatchData } from "@ebay-business-components/favorites-utils/dist/interface";
import type WatchService from "@ebay-business-components/favorites-utils/dist/services/watch-service-provider";
import type { ItemCard } from "@ebay/experience-types-ebay";
import { t } from "@ebay/i18n-ebay";
import { textFromTD } from "../../utils/text";
import type { WatchListEntries } from "../map/types";

export type Input = {
  model: ItemCard;
  localizedContent?: LocalizedContent;
  watchInstance?: WatchService | null;
  watchListItems?: WatchListEntries;
  handleWatchListItemToggle?: (listingid: string) => void;
};

export type State = {
  itemDetails: WatchData;
  itemTitle: string;
};

export default class extends Marko.Component<Input, State> {
  onCreate() {
    this.state = {
      itemTitle: "",
      itemDetails: {
        itemData: {
          isWatched: false,
          isMSKU: false,
          itemId: "",
        },
      },
    };
  }

  onInput(input: Input) {
    this.state.itemDetails.itemData.itemId = input.model.listingId ?? "";
    this.state.itemDetails.itemData.isWatched = !!input.watchListItems?.find((entry) => entry?.item?.listing?.listingId === input.model.listingId);
    this.state.itemTitle = textFromTD(input.model.title);
  }

  handleWatchUpdate(response: any) {
    if ("redirectURL" in response && response.redirectURL) {
      // Check if the page is rendered inside an iframe
      if (window !== window.top) {
        return window.top?.location.assign(response.redirectURL);
      } else {
        return window.location.assign(response.redirectURL);
      }
    }

    // In this case we confirm from favorites-ui that the watch action was successful
    if ("isWatched" in response && typeof response.isWatched === "boolean") {
      this.state.itemDetails.itemData.isWatched = response.isWatched;
      this.input.handleWatchListItemToggle?.(this.input.model.listingId ?? "");
    }
  }

  handleToggleWatchAction(response: any) {
    if ("isMSKUWithValidVariation" in response && response.isMSKUWithValidVariation) {
      if ("itemData" in response && response.itemData.itemId === this.state.itemDetails.itemData.itemId) {
        this.state.itemDetails.itemData.isWatched = !this.state.itemDetails.itemData.isWatched;
      }
    }
  }

  getAccessibilityLabel() {
    const { isWatched } = this.state.itemDetails?.itemData ?? {};
    const itemTitle = this.state.itemTitle;
    if (isWatched) {
      return t("mapview/map", "unwatchItemLabel");
    }
    const watchLabel = t("mapview/map", "watchItemLabel");
    return itemTitle ? `${watchLabel} ${itemTitle}` : watchLabel;
  }
}
